import React from "react";
import { withSitecoreContext, Image } from "@sitecore-jss/sitecore-jss-react";
import { useSelector } from "react-redux";
const ModalImagery = ({
  sitecoreContext,
  displayLogo = true,
  displayBg = true,
  logoClass = "account__logo",
  backgroundClass = "account__decoration"
}) => {
  const global = useSelector(state => state.global);
  const modalSettings = sitecoreContext.modalSettings;
  return /*#__PURE__*/React.createElement(React.Fragment, null, displayLogo && modalSettings.ModalLogo && modalSettings.ModalLogo.value && modalSettings.ModalLogo.value.src && /*#__PURE__*/React.createElement(Image, {
    className: logoClass,
    width: "103",
    height: "44",
    media: modalSettings.ModalLogo,
    imageParams: {
      w: 200,
      h: "auto",
      mw: 200
    }
  }), displayBg && !global.isMobile && modalSettings.ModalBackgroundImage && modalSettings.ModalBackgroundImage.value && modalSettings.ModalBackgroundImage.value.src && /*#__PURE__*/React.createElement(Image, {
    className: backgroundClass,
    width: "200",
    height: "200",
    media: modalSettings.ModalBackgroundImage,
    imageParams: {
      w: 200,
      h: "auto",
      mw: 200
    }
  }));
};
export default withSitecoreContext()(ModalImagery);